import type { paths } from '@fluencelabs/vodopad-admin-api'
import createClient from 'openapi-fetch'

import { VODOPAD_ENDPOINT } from '@/constants/constants'

import { authMiddleware } from './authMiddleware'

export const client = createClient<paths>({
  baseUrl: VODOPAD_ENDPOINT,
})

client.use(authMiddleware)

export default client
